import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {retry, catchError, tap, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';

import {DetailInfoService} from '../../services/details-info.service';
import {environment} from '../../../../../../environments/environment';
import {ProductOverviewRequest} from '../../../../../services/product-overview/product-overview-request.model';
import {OnlineKeySearchResponseModel} from '../../screens/models/Onlinekeys-search.model';

export interface OnlineKeySearchRequestModel {
  arrangementNumbers: string[];
  selectedPage: number;
  searchValue: string;
  relationRestrictedDataView: boolean;
  restrictedDataViewException: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class OnlineKeyService {

  private onlineKeyServiceURL;

  constructor(private http: HttpClient, private readonly detailInfoService: DetailInfoService) {
    this.onlineKeyServiceURL = `${environment.civServicesBaseURL}onlinekeys/search`;
  }

  public searchOnlineKeys(params: any): Observable<OnlineKeySearchResponseModel> {
    const headers = this.prepareHeaders();
    const body = this.prepareBody(params);
    return this.http.post<OnlineKeySearchResponseModel>(this.onlineKeyServiceURL, body, { headers })
      .pipe(map((res) => res));
  }

  private prepareHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', ProductOverviewRequest.token);
    headers = headers.append('MFA-Authorization', ProductOverviewRequest.token);
    headers = headers.append('Graph-Authorization', ProductOverviewRequest.graphToken);
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }

  private prepareBody(params: OnlineKeySearchRequestModel): OnlineKeySearchRequestModel {
    const body: OnlineKeySearchRequestModel = {
      arrangementNumbers: this.detailInfoService.detailScreenInfo.arrangementNumbers || [],
      selectedPage: params.selectedPage || 1,
      searchValue: params.searchValue || '',
      relationRestrictedDataView: this.detailInfoService.detailScreenInfo.relationRestrictedDataView || false,
      restrictedDataViewException: this.detailInfoService.detailScreenInfo.restrictedDataViewException || false,
    };

    return body;
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
